module.exports = __webpack_public_path__ + "static/media/homepod.e3172634.png";